export { default } from './FETranscriptionPoc';
